import { EaveType, FasciaTopTrimSize } from "building-types/settings/settingsTypesEnum";

export const fasciaTopTrimSizeToValue: {
  [key in FasciaTopTrimSize]: number;
} = {
  [FasciaTopTrimSize.TWO_INCH]: 2,
  [FasciaTopTrimSize.THREE_INCH]: 3,
  [FasciaTopTrimSize.FOUR_INCH]: 4,
};

export const isOpenEave: {
  [key in EaveType]?: boolean;
} = {
  [EaveType.BOXED_OPEN]: true,
  [EaveType.ANGLED_ENCLOSED_OPEN]: true,
  [EaveType.ANGLED_OPEN_OPEN]: true,
};

export const isBoxEave: {
  [key in EaveType]?: boolean;
} = {
  [EaveType.BOXED_BOX]: true,
  [EaveType.BOXED_MINI_HIP]: true,
  [EaveType.BOXED_MINI_SHED]: true,
};

export const isAngledEave: {
  [key in EaveType]?: boolean;
} = {
  [EaveType.ANGLED_ENCLOSED_OPEN]: true,
  [EaveType.ANGLED_OPEN_OPEN]: true,
};

export const hasEaveSoffit: {
  [key in EaveType]?: boolean;
} = {
  [EaveType.BOXED_BOX]: true,
  [EaveType.BOXED_OPEN]: true,
  [EaveType.BOXED_MINI_HIP]: true,
  [EaveType.BOXED_MINI_SHED]: true,
  [EaveType.BOXED_FULL_RETURN]: true,
};
